import cookies from 'js-cookie'

export const getCookie = (name: string) => {
  const cookie: string = cookies.get(name) as string
  return cookie
}
export const setCookie = (name: string, value: any, expires = 1) => {
  return cookies.set(name, value, { expires })
}
export const removeCookie = (name: string) => {
  cookies.remove(name)
}
